import React, { FC } from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const CloseLightIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.75 11.7188C13.0312 12.0312 13.0312 12.5 12.75 12.7812C12.4375 13.0938 11.9688 13.0938 11.6875 12.7812L8 9.0625L4.28125 12.7812C3.96875 13.0938 3.5 13.0938 3.21875 12.7812C2.90625 12.5 2.90625 12.0312 3.21875 11.7188L6.9375 8L3.21875 4.28125C2.90625 3.96875 2.90625 3.5 3.21875 3.21875C3.5 2.90625 3.96875 2.90625 4.25 3.21875L8 6.96875L11.7188 3.25C12 2.9375 12.4688 2.9375 12.75 3.25C13.0625 3.53125 13.0625 4 12.75 4.3125L9.03125 8L12.75 11.7188Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
